/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetHelpSite200ResponseData } from './GetHelpSite200ResponseData'
import {
  GetHelpSite200ResponseDataFromJSON,
  GetHelpSite200ResponseDataFromJSONTyped,
  GetHelpSite200ResponseDataToJSON,
} from './GetHelpSite200ResponseData'

/**
 *
 * @export
 * @interface GetHelpSite200Response
 */
export interface GetHelpSite200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetHelpSite200Response
   */
  status: boolean
  /**
   *
   * @type {GetHelpSite200ResponseData}
   * @memberof GetHelpSite200Response
   */
  data: GetHelpSite200ResponseData
}

/**
 * Check if a given object implements the GetHelpSite200Response interface.
 */
export function instanceOfGetHelpSite200Response(
  value: object
): value is GetHelpSite200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetHelpSite200ResponseFromJSON(
  json: any
): GetHelpSite200Response {
  return GetHelpSite200ResponseFromJSONTyped(json, false)
}

export function GetHelpSite200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetHelpSite200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetHelpSite200ResponseDataFromJSON(json['data']),
  }
}

export function GetHelpSite200ResponseToJSON(
  value?: GetHelpSite200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetHelpSite200ResponseDataToJSON(value['data']),
  }
}
